import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Pagination from '@mui/material/Pagination';

import {
    alertActions,
    breadcrumbsActions,
    discoveryActions as myActions,
    fullProfilesActions, userProjectsActions,
} from '../../../_services/essentials/store';
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { DataGrid } from "@mui/x-data-grid";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import TuneIcon from '@mui/icons-material/Tune';
import {Chip, FormControl, InputLabel, MenuItem, OutlinedInput, Select, TextField, Tooltip} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { history } from "../../../_services/essentials/helpers";
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { Tab, Tabs } from "@mui/material";
import PropTypes from "prop-types";
import Avatar from "@mui/material/Avatar";
import { useGridApiRef } from '@mui/x-data-grid'
import Search from '../../../_components/common/Search';
import {ArrowForwardOutlined, TabUnselectedRounded} from '@mui/icons-material';
import CircularProgress from '@mui/material/CircularProgress';
import ReactCountryFlag from "react-country-flag"
import moment from 'moment';
import IconButton from "@mui/material/IconButton";

import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import Person2Icon from '@mui/icons-material/Person2';
import TagIcon from '@mui/icons-material/Tag';
import ClearIcon from '@mui/icons-material/Clear';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import CancelIcon from "@mui/icons-material/Cancel";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import SearchIcon from '@mui/icons-material/Search';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import AddIcon from '@mui/icons-material/Add';
import InsightsIcon from '@mui/icons-material/Insights';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';
import ShowChartIcon from '@mui/icons-material/ShowChart';

import { styled } from "@mui/system";

import SocialmediaIcon from "../../../_components/internals/components/socialmedia-icons/SocialmediaIcon";

export { IdentifiedProfileList };

function IdentifiedProfileList() {

    //    const { project_id } = useParams();
    const dispatch = useDispatch();

    // const entity_name = "full_profile";
    // const entity_label = "Profile";
    // const entities_name = "full_profiles";
    //const entities_label = "Profiles";
    const gridApiRef = useGridApiRef();

    const entity = useSelector(x => x.discovery?.filter);

    const listAPIResponse = useSelector(x => x.fullProfiles?.listAPIResponse);
    const userProject = useSelector(x => x.userProjects?.item);
    const userProjects = useSelector(x => x.userProjects?.listAPIResponse);
    const loggedInUser = useSelector(x => x.auth.loggedInUser);
    // const entities = listAPIResponse?.value?.list;
    const totalItems = listAPIResponse?.value?.totalItems;

    const [loading, setLoading] = useState(true);
    const [entities, setEntities] = useState([]);
    const [totalPages, setTotalPages] = useState('');
    const textEllipsis = {
        display: '-webkit-box',
        WebkitLineClamp: 3,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'normal',

    };

    dispatch(breadcrumbsActions.setCurrentURL({
        url: history.location?.pathname,
        state: history.location?.state
    }));

    const validationSchema = Yup.object().shape({
        name: Yup.string()
            .trim()
            .required('Required*')
            .max(60, 'Cannot exceed 60 characters'),
        description: Yup.string()
            .trim()
            .required('Required*')
            .max(250, 'Cannot exceed 250 characters'),
        geographicScope: Yup.string()
            .trim()
            .required('Required*')
            .max(60, 'Cannot exceed 60 characters'),
        keywordOrTherapeuticArea: Yup.string()
            .trim()
            .required('Required*')
            .max(60, 'Cannot exceed 60 characters'),
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    const { register, handleSubmit, reset, formState } = useForm(formOptions);
    const { register: registerForm2, handleSubmit: handleSubmit2, control, reset: reset2 } = useForm();
    const { errors } = formState;
    const [filterModifiedFlag, setFilterModifiedFlag] = useState(false);

    const [showDiscoveryFilter, setShowDiscoveryFilter] = useState(history.location?.state?.show_discovery_filter);

    const [discoveryFilter, setDiscoveryFilter] = useState(history.location?.state?.discovery_filter);
    const [selectedModuleId, setSelectedModuleId] = React.useState(0);

    const [masterProfileFilter, setMasterProfileFilter] = useState({
        searchTerms: '',
        discoveryFilter: discoveryFilter ? JSON.stringify(discoveryFilter) : "",
        selectedModuleId: selectedModuleId
    });

    const [dataFilter, setDataFilter] = useState({
        masterProfileFilter: masterProfileFilter
    });

    const [sortModel, setSortModel] = React.useState([
        {
            field: 'firstname',
            sort: 'asc',
        }
    ]);

    const [pageFilter, setPageFilter] = useState({
        pageNumber: 1,
        pageSize: 50,
        sortField: sortModel[0]?.field || 'firstname',
        sortDirection: sortModel[0]?.sort || 'asc',
        dataFilter: dataFilter
    });

    const [openCreateProjectPopup, setOpenCreateProjectPopup] = useState(false);
    const [selectedTab, setSelectedTab] = React.useState(0);
    const [selectedProfileIds, setSelectedProfileIds] = useState('');
    const [selectedUserProjectId, setSelectedUserProjectId] = useState(-1);
    const [onLoadWait, setOnLoadWait] = useState(true);

    let allContinentsInMemory = null;

    useEffect(() => {
        if (
            listAPIResponse &&
            listAPIResponse.value &&
            Array.isArray(listAPIResponse.value.list)) {
            setLoading(true);
            setEntities(listAPIResponse?.value?.list);
            setTotalPages(listAPIResponse?.value?.totalPages);
            setLoading(false);
        }
    }, [listAPIResponse, selectedModuleId]);

    useEffect(() => {
        // dispatch(breadcrumbsActions.setCurrentTitle(`Identification`));
        dispatch(breadcrumbsActions.setCurrentTitle(``));

        if (!(entity?.specialities?.value?.loading) && !(entity?.specialities?.value)) {
            dispatch(myActions.getAllSpecialities()).unwrap();
        } else {
            if (entity?.specialities?.value) {
                setFilterModifiedFlag(true);
            }
        }

        if (!(entity?.continents?.value?.loading) && !(entity?.continents?.value)) {
            dispatch(myActions.getAllContinents()).unwrap();
        } else {
            if (entity?.continents?.value) {
                setFilterModifiedFlag(true);
            }
        }

        if ((!(entity?.search_terms?.value?.loading) && !(entity?.search_terms?.value)) || (entity?.search_terms?.value && JSON.stringify(entity?.search_terms?.value)==='{}')) {
            dispatch(myActions.getAllSearchTerms()).unwrap();
        } else {
            if (entity?.search_terms?.value) {
                setFilterModifiedFlag(true);
            }
        }

        dispatch(myActions.getAllProfessionalActivities()).unwrap();
        dispatch(myActions.getAllProfileCompletenessOptions()).unwrap();

    }, [dispatch] );


    useEffect(() => {
        //alert('JSON.stringify(discoveryFilter): '+JSON.stringify(discoveryFilter));
        setMasterProfileFilter({
            ...masterProfileFilter,
            discoveryFilter: discoveryFilter ? JSON.stringify(discoveryFilter) : "",
            selectedModuleId: selectedModuleId
        });
    }, [discoveryFilter, selectedModuleId]);

    useEffect(() => {
        setSortModel([]);
        updatePageFilter({
            ...pageFilter,
            pageNumber: 1,
            sortField: 'firstname',
            sortDirection: 'asc',
            dataFilter: {
                masterProfileFilter: masterProfileFilter
            }
        });
    }, [masterProfileFilter]);

    async function resetDiscoveryFilter() {
        reset2();
        await dispatch(myActions.getAllSpecialities()).unwrap();
        await dispatch(myActions.getAllContinents()).unwrap();
        await dispatch(myActions.getAllSearchTerms()).unwrap();
        await dispatch(myActions.getAllProfessionalActivities()).unwrap();
        await dispatch(myActions.getAllProfileCompletenessOptions()).unwrap();

        setDiscoveryFilter({});
    }

    async function searchProfile(data) {
        dispatch(alertActions.clear());
//        alert('data: '+JSON.stringify(data));
        try {
            const newSearchTerms = data.new_search_terms;
            setLoading(true);

            setMasterProfileFilter({
                ...masterProfileFilter,
                searchTerms: newSearchTerms
            }
            );

            // updatePageFilter({
            //     pageNumber: 1,
            //     dataFilter: {
            //         masterProfileFilter: {
            //             searchTerms: newSearchTerms,
            //             discoveryFilter: discoveryFilter ? JSON.stringify(discoveryFilter) : ""
            //         }
            //     }
            // });
        } catch (error) {
            dispatch(alertActions.error(error));
        }
    }
    useEffect(() => {
        if(!onLoadWait) {
            setLoading(true);
        dispatch(fullProfilesActions.getPaginatedList(pageFilter));
        }
    }, [pageFilter, onLoadWait]);

    useEffect(() => {
        if(onLoadWait){
            setLoading(true);
            const timeoutId = setTimeout(() => {
                setOnLoadWait(false);
            }, 100);

            return () => clearTimeout(timeoutId);
        }
    }, [onLoadWait]);

    const updatePageFilter = (updates = {}) => {
        setLoading(true);
        setPageFilter((prev) => ({
            ...prev,
            ...updates,
        }));
    };

    // useEffect(() => {
    //     setPageFilter({
    //         ...pageFilter,
    //         pageNumber: 1,
    //         pageSize: 50,
    //         sortField: sortModel[0]?.field,
    //         sortDirection: sortModel[0]?.sort,
    //     });
    // }, [sortModel]);

    function navigatePage(event, newPageNumber) {
        setLoading(true);

        setPageFilter({
            ...pageFilter, // copy the current properties of "json"
            pageNumber: newPageNumber // update the "name" property
        });

    }

    // function uxTextAvatar(name) {
    //     return {
    //         sx: {
    //             bgcolor: stringToColor(name),
    //             width: 35, height: 35,
    //             fontSize: '14px'
    //         },
    //         children: stringAvatar(name),
    //     };
    // }
    //
    //
    // function stringAvatar(name) {
    //     if (name) {
    //         let names = name.split(' ');
    //         if (names[0] && names[1]) {
    //             return `${names[0][0]} ${names[1][0]}`;
    //         } else {
    //             return names[0][0];
    //         }
    //     } else {
    //         return ``;
    //     }
    // }

    function stringToColor(inputString) {
        let hash = 0;
        let i;

        /* eslint-disable no-bitwise */
        for (i = 0; i < inputString.length; i += 1) {
            hash = inputString.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = '#';

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */

        return color;
    }

    function renderColumns() {
        const kolCardColumn = {
            field: 'firstname',
            renderHeader: () => (<h6><strong>{'KOL Card'}</strong></h6>),
            // flex: 0.25,
            //headerAlign: 'center',
            minWidth: 370,
            renderCell: (params) =>
                <Stack direction="row" sx={{py: 1, alignItems: 'center'}}>
                    <Stack direction="column"
                           justifyContent="center"
                           alignItems="left"
                    >
                        {(params.row.profileImage?.imageLink && params.row.profileImage?.imageLink?.length > 0) ? (
                            <Avatar
                                // alt={stringAvatar(`${params.row.firstname} ${params.row.lastname}`)}
                                src={`${params.row.profileImage?.imageLink}`}
                                sx={{width: 42, height: 42, userSelect: 'none'}}
                                slotProps={{
                                    img: {
                                        loading: "lazy",
                                    },
                                }}
                            />
                        ) : (
                            // <Avatar {...uxTextAvatar(`${params.row.firstname} ${params.row.lastname}`)} sx={{ width: 42, height: 42 }} />
                            <Avatar
                                // alt={stringAvatar(`${params.row.firstname} ${params.row.lastname}`)}
                                src={null}
                                sx={{width: 42, height: 42, userSelect: 'none'}}
                                slotProps={{
                                    img: {
                                        loading: "lazy",
                                    },
                                }}
                            />
                        )}
                        {/* {params.row.salutation} {params.row.firstname} {params.row.lastname} {params.row.suffix} */}
                    </Stack>
                    <Stack direction="column" sx={{ml: 2, justifyContent: 'left'}}>
                        <Typography variant="subtitle1" sx={{fontSize: '18px', userSelect: 'none'}}>
                            {params.row.salutation} {params.row.firstname} {params.row.lastname}
                            <span style={{fontSize: '12px'}}> {params.row.suffix}</span>
                        </Typography>
                        <Typography variant="body2" sx={{
                            color: '#4C58B2',
                            fontWeight: '600',
                            userSelect: 'none'
                        }}> {params.row.title}</Typography>


                        <Typography
                            variant="caption"
                            sx={{
                                lineHeight: '24px',
                                fontWeight: '500',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                userSelect: 'none'
                            }}
                        >
                            <ReactCountryFlag
                                countryCode={params.row.countryRef.code}
                                svg
                                style={{
                                    width: "20px",
                                    height: "20px",
                                }}
                                title={params.row.countryRef.name}
                            />
                            {params.row.countryRef.name}
                        </Typography>

                    </Stack>
                </Stack>
        };

        const affiliationColumn = {
            field: 'primaryAffiliation',
            renderHeader: () => (<h6><strong>{'Affiliation / University'}</strong></h6>),

            flex: .8,
            // height: 70,
            minWidth: 100,
            renderCell: (params) =>
                <Stack direction="row" sx={{
                    py: 1, alignItems: 'center', width: '100%'
                }}>
                    <Stack direction="column"
                           justifyContent="center"
                           alignItems="left">
                        <Typography variant="body1" sx={{
                            userSelect: 'none'
                        }}>
                            {params.row.primaryAffiliation}
                        </Typography>
                    </Stack>
                </Stack>
        };

        const specialtyColumn = {
            field: 'specialty',
            renderHeader: () => (<h6><strong>{'Speciality'}</strong></h6>),
            flex: .8,
            minWidth: 80,
            renderCell: (params) =>
                <Stack direction="row" sx={{
                    py: 1, alignItems: 'center', width: '100%'
                }}>
                    <Tooltip title={<Typography
                        sx={{userSelect: 'none', fontSize: '11px'}}>{params.row.specialty}</Typography>}>
                        <Stack sx={textEllipsis}>
                            <Typography variant="body1" sx={{userSelect: 'none'}}>
                                {params.row.specialty}
                            </Typography>
                        </Stack>
                    </Tooltip>
                </Stack>
        };

        const areasOfInterestsColumn = {
            field: 'areasOfInterests',
            renderHeader: () => (<h6><strong>{'Area of Research'}</strong></h6>),
            flex: 1,
            minWidth: 250,
            renderCell: (params) =>
                <Box
                    sx={{
                        position: 'relative',
                        display: 'inline-block',
                        width: '100%',
                        pt: 1
                    }}
                >
                    <Tooltip title={<Typography sx={{
                        userSelect: 'none',
                        fontSize: '11px'
                    }}>{params.row.areasOfInterests}</Typography>}>
                        <Stack sx={textEllipsis}>
                            <Typography variant="body1" sx={{userSelect: 'none'}}>
                                {params.row.areasOfInterests}
                            </Typography>
                        </Stack>
                    </Tooltip>


                    <Box
                        sx={{
                            position: 'absolute',
                            top: 1,
                            right: 0,
                            color: 'background.paper',
                            fontSize: '10px',
                            visibility: 'hidden',
                            opacity: 0,
                            transition: 'visibility 0s, opacity 0.2s ease-in-out',
                            zIndex: 1,
                            userSelect: 'none'
                        }}
                        className="corner-value"
                    >
                        <strong>Last Updated :</strong>
                        {moment(params.row?.lastUpdatedTime).format('DD-MM-YYYY')}
                    </Box>
                </Box>
        };

        const socialMediaAccountsColumn = {
            field: 'socialMediaAccounts',
            renderHeader: () => (<h6><strong>{'Social Media Accounts'}</strong></h6>),
            flex: 1,
            minWidth: 200,
            sortable: false,
            renderCell: (params, index)  =>
                <Box
                    sx={{
                        position: 'relative',
                        display: 'inline-block',
                        width: '100%',
                        pt: 1
                    }}
                >
                    <Stack direction="row" sx={{mr: 1, mb: 0, gap: 1, justifyContent: 'left', flexGrow: '1', flexWrap: 'wrap'}}>
                        {/*Reference: https://www.npmjs.com/package/react-social-icons*/}
                        {/*Reference: https://github.com/couetilc/react-social-icons*/}
                        {params.row.socialMediaAccounts?.map((socialMediaAccount) => (
                            <SocialmediaIcon smapp={socialMediaAccount?.socialMediaApp} socialMediaUrl={socialMediaAccount?.socialMediaUrl} />
                        ))
                        }
                    </Stack>
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 1,
                            right: 0,
                            color: 'background.paper',
                            fontSize: '10px',
                            visibility: 'hidden',
                            opacity: 0,
                            transition: 'visibility 0s, opacity 0.2s ease-in-out',
                            zIndex: 1,
                            userSelect: 'none'
                        }}
                        className="corner-value"
                    >
                        <strong>Last Updated :</strong>
                        {moment(params.row?.lastUpdatedTime).format('DD-MM-YYYY')}
                    </Box>
                </Box>
        };

        const profileCompletenessPercentageColumn = {
            field: 'profileCompletenessPercentage',
            renderHeader: () => (<></>),
            flex: 0.1,
            Width: 1,
            minWidth: 1,
            sortable: false,
            renderCell: (params) =>
                <Stack
                    sx={{
                        display: 'inline-block',
                        //width: '0.5px',
                        height: '100%',
                        pt: 1,
                        pb: 1,
                        pl: 1,
                        //verticalAlign: 'center',
                        align: 'right',
                        //border:1
                    }}
                >
                    <Box
                        sx={{
                            position: 'relative',
                            display: 'inline-block',
                            width: '8px',
                            height: '100%',
                            //border: 1,
                            borderColor: '#aed6f1',
                            //bgcolor: '#FFFFCC'
                            bgcolor: `${params.row.profileCompletenessPercentage === 100 ? '#82e0aa' : '#f7dc6f'}`,
                        }}
                    >
                    </Box>
                </Stack>
        };

        switch (selectedModuleId) {
            case 0:
                return [kolCardColumn, affiliationColumn, specialtyColumn, areasOfInterestsColumn, profileCompletenessPercentageColumn];
            case 1:
                return [kolCardColumn, affiliationColumn, specialtyColumn, areasOfInterestsColumn, profileCompletenessPercentageColumn];
            case 2:
                return [kolCardColumn, affiliationColumn, specialtyColumn, areasOfInterestsColumn, socialMediaAccountsColumn, profileCompletenessPercentageColumn];
            case 3:
                return [kolCardColumn, affiliationColumn, specialtyColumn, areasOfInterestsColumn, profileCompletenessPercentageColumn];
        }

    }

    const CreateProjectPopupStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 526,
        bgcolor: 'background.modal',
        // border: '2px solid #000',
        boxShadow: 24,
        borderRadius: '10px'
    };

    async function handleCreateProjectPopupOpen() {
        setSelectedTab(0);
        const newProjectEntity = {
            user: loggedInUser,
            name: "",
            description: "",
            commentAndQuestion: "",
            geographicScope: "",
            communicationMode: { "id": 1 },
            keywordOrTherapeuticArea: "",
            // privacyPolicyAcknowledgement: false,
            type: { "id": 2 },
            status: { "id": 1 }
        };
        await dispatch(userProjectsActions.getNewEntity(newProjectEntity)).unwrap();
        setOpenCreateProjectPopup(true);
        reset();


    }

    async function handleCreateProjectAndAddProfiles(data) {
        const response = await dispatch(userProjectsActions.create({ data })).unwrap();
        //const message = response ? response.message : '';
        const newProjectId = response ? response.id : -1;
        if (newProjectId > 0) {
            let payload = {
                "selected_user_project_id": newProjectId,
                "selected_profile_ids": JSON.stringify(selectedProfileIds)
            };
            const message = await dispatch(userProjectsActions.addProfilesToProject(payload)).unwrap();
            await dispatch(alertActions.success({ message, showAfterRedirect: false }));
            gridApiRef.current.setRowSelectionModel([]);
            setOpenCreateProjectPopup(false);
            reset();
        } else {
            const error_message = "Error occurred while creating new project";
            await dispatch(alertActions.error({ error_message, showAfterRedirect: false }));
        }

    }

    async function handleOpenProjectAndAddProfiles() {

        //dispatch(alertActions.clear());
        let payload = {
            "selected_user_project_id": selectedUserProjectId,
            "selected_profile_ids": JSON.stringify(selectedProfileIds)
        };

        const message = await dispatch(userProjectsActions.addProfilesToProject(payload)).unwrap();
        await dispatch(alertActions.success({ message, showAfterRedirect: false }));
        gridApiRef.current.setRowSelectionModel([]);
        setOpenCreateProjectPopup(false);
    }

    function handleCreateProjectPopupClose() {
        setOpenCreateProjectPopup(false);
    }

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        //newValue===0 ? setSelectedTabColor('#efe2ba') : setSelectedTabColor('#e3e2df');
        if (newValue === 1) {
            const pageFilter = {
                "pageNumber": 1,
                "pageSize": 100000,
                "sortField": "status.sortOrder, lastUpdatedTime",
                "sortDirection": "asc, desc",
                "dataFilter":              {
                    "userProjectFilter": {
                        activeStatusGroupFlag: true,
                        userId: loggedInUser?.id,
                        searchTerms: ""
                    }
                }
            };
            dispatch(userProjectsActions.getPaginatedList(pageFilter));
            setSelectedUserProjectId(-1);
        }

    };

    function CustomTabPanel(props) {
        const { children, value, backgroundColor, index, ...other } = props;

        return (
            <Box
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                minHeight={'200px'}
                sx={{ flexDirection: 'row', mb: 3 }}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index &&
                    <Stack direction="column" sx={{
                        justifyContent: 'center',
                        alignItems: 'center'
                        // background: backgroundColor,
                        // border: '0px solid #0052eb',
                        // borderColor: '#777',
                        // backdropFilter: 'blur(1px)',
                        // borderRadius: '12px'

                    }}>
                        {children}
                    </Stack>
                }
            </Box>
        );
    }

    CustomTabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleDiscoveryTabChange = (event, newValue) => {

        //newValue===0 ? setSelectedTabColor('#efe2ba') : setSelectedTabColor('#e3e2df');
        if (newValue === 0) {
            setSelectedModuleId(newValue);
        } else if (newValue === 1) {
            setSelectedModuleId(newValue);
        } else if (newValue === 2) {
            setSelectedModuleId(newValue);
        } else if (newValue === 3) {
            let message = "Implementation in Progress";
            dispatch(alertActions.info({ message, showAfterRedirect: false }));
            //setSelectedModuleId(newValue);
        }

    };

    function CustomDiscoveryTabPanel(props) {
        const { children, value, backgroundColor, index, ...other } = props;

        return (
            <Box
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                minHeight={'200px'}
                sx={{ flexDirection: 'row', mb: 3 }}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index &&
                <Stack direction="column" sx={{
                    justifyContent: 'center',
                    alignItems: 'center'
                    // background: backgroundColor,
                    // border: '0px solid #0052eb',
                    // borderColor: '#777',
                    // backdropFilter: 'blur(1px)',
                    // borderRadius: '12px'

                }}>
                    {children}
                </Stack>
                }
            </Box>
        );
    }

    CustomDiscoveryTabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    const CustomDiscoveryTab = styled(Tab)(({ theme }) => ({
        // width: 300,
        // color: theme.palette.success.main,
        '&:hover': {
            backgroundColor: '#767eff',
        },
        "&.MuiTab-root": {
            backgroundColor: "#e2ecff",
            // borderLeft: '1px solid #90A1B9',
            // borderRight: '1px solid #90A1B9',
            // borderTopRightRadius: 10,
            // borderTopLeftRadius: 10,
            // borderColor: "#373985",
            color: '#000000',
            minHeight: 44,
            height: 44,
            // borderBottom: "2px solid",
            // "&:hover": {
            //     border: 0,
            //     borderBottom: "2px solid",
            // },
        },
        "&.Mui-selected": {
            backgroundColor: "#4C58B2",
//            borderTop: "2px solid #373985",
            borderColor: "#373985",
            color: '#ffffff',
            height: '5px',
        }
    }));

    function a11yDiscoveryProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    async function onSubmit(data) {
        dispatch(alertActions.clear());
        try {
            // create or update user based on id param
            //            let message;
            //            const response = await dispatch(myActions.setFilter(data)).unwrap();
            // redirect to user list with success message
            //            history.navigate(`/discovery/identified_profiles`);
            //dispatch(alertActions.success({ message, showAfterRedirect: true }));
            //            alert('data: '+JSON.stringify(data));
            //            history.navigate(`/discovery/identified_profiles?time=${new Date()}`, {replace: true},  {state:{discovery_filter: data, show_discovery_filter: true}});


            // await setDataFilter({
            //     masterProfileFilter: {
            //         discoveryFilter: JSON.stringify(data)
            //     }
            // });

            // const filteredData = {
            //     specialities: entity.specialities.value,
            //     continents: entity.continents.value,
            //     search_terms: JSON.stringify(entity.search_terms.value)
            // };
            //
            // alert('filteredData: '+JSON.stringify(filteredData));

            setDiscoveryFilter(data);
//            setDiscoveryFilter(filteredData);


            // setMasterProfileFilter({
            //     ...masterProfileFilter,
            //     discoveryFilter: JSON.stringify(data)
            // }
            // );

        } catch (error) {
            dispatch(alertActions.error(error));
        }
    }

    async function searchFilter(data) {
        dispatch(alertActions.clear());
        try {
            // create or update user based on id param
            //            let message;
            //            const response = await dispatch(myActions.setFilter(data)).unwrap();
            // redirect to user list with success message
            //            history.navigate(`/discovery/identified_profiles`);
            //dispatch(alertActions.success({ message, showAfterRedirect: true }));
            //            alert('data: '+JSON.stringify(data));
            //            history.navigate(`/discovery/identified_profiles?time=${new Date()}`, {replace: true},  {state:{discovery_filter: data, show_discovery_filter: true}});

            setLoading(true);
            // await setDataFilter({
            //     masterProfileFilter: {
            //         discoveryFilter: JSON.stringify(data)
            //     }
            // });
            //
            // await setPageFilter({
            //     ...pageFilter,
            //     pageNumber: 1,
            //     dataFilter: {
            //         masterProfileFilter: {
            //             discoveryFilter: JSON.stringify(data)
            //         }
            //     }
            // });

            const filteredData = {
                specialities: entity.specialities.value,
                continents: entity.continents.value,
                search_terms: entity.search_terms.value,
                professional_activities: entity.professional_activities.value,
                profile_completeness_options: entity.profile_completeness_options.value
            };

            //setDiscoveryFilter(data);
            setDiscoveryFilter(filteredData);

        } catch (error) {
            dispatch(alertActions.error(error));
        }
    }

    async function handleCountrySelection (continentId, countryId, selectionFlag){
        const allContinents = allContinentsInMemory ? allContinentsInMemory : entity.continents.value;
        let continentObjectWithSelectedContinent = allContinents.filter(item => item.id === continentId);
        const allCountriesFromSelectedContinent = continentObjectWithSelectedContinent[0].countries;
        let countryObject = allCountriesFromSelectedContinent.filter(item => item.id === countryId)[0];

        countryObject = {
            ...countryObject,
            selected: selectionFlag
        };

        let allUpdatedCountriesFromSelectedContinent = [];

        await allCountriesFromSelectedContinent.map(country => {
            if(country.id === countryId) {
                allUpdatedCountriesFromSelectedContinent.push(countryObject);
            } else {
                allUpdatedCountriesFromSelectedContinent.push(country);
            }
        });

        let allUpdatedContinents = [];

        await allContinents.map(continent => {
            if(continent.id === continentId) {
                allUpdatedContinents.push(
                    {
                        ...continent,
                        countries: allUpdatedCountriesFromSelectedContinent
                    });
            } else {
                allUpdatedContinents.push(continent);
            }
        });

        allContinentsInMemory = allUpdatedContinents;
    }

    async function renderUpdatedCountrySelectionList() {

        if (allContinentsInMemory) {
            await dispatch(myActions.updateContinentFilter(allContinentsInMemory)).unwrap();
            allContinentsInMemory = null;
        }
    }

    async function setShowCountryfilterByContinentId (continentId, selectionFlag){
        const allContinents = entity.continents.value;
        let continentObjectWithSelectedContinent = allContinents.filter(item => item.id === continentId)[0];

        continentObjectWithSelectedContinent = {
            ...continentObjectWithSelectedContinent,
            showCountryFilter: selectionFlag
        };

        let allUpdatedContinents = [];

        await allContinents.map(continent => {
            if(continent.id === continentId) {
                allUpdatedContinents.push(continentObjectWithSelectedContinent);
            } else {
                allUpdatedContinents.push(continent);
            }
        });

        //allContinentsInMemory = allUpdatedContinents;
        dispatch(myActions.updateContinentFilter(allUpdatedContinents)).unwrap();

    }

    async function handleContinentSelection (continentId, selectionFlag){
        const allContinents = allContinentsInMemory ? allContinentsInMemory : entity.continents.value;
        let continentObjectWithSelectedContinent = allContinents.filter(item => item.id === continentId);

        let continentObject = continentObjectWithSelectedContinent[0];

        continentObject = {
            ...continentObject,
            selected: selectionFlag
        };

        let allUpdatedContinents = [];

        await allContinents.map(continent => {
            if(continent.id === continentId) {
                allUpdatedContinents.push(continentObject);
            } else {
                allUpdatedContinents.push(continent);
            }
        });

        await dispatch(myActions.updateContinentFilter(allUpdatedContinents)).unwrap();
    }

    async function handleSpecialitiesSelection (specialityId, selectionFlag){
        const allSpecialities = entity.specialities.value;
        let selectedSpecialityObject = allSpecialities.filter(item => item.id === specialityId);

        let specialityObject = selectedSpecialityObject[0];

        specialityObject = {
            ...specialityObject,
            selected: selectionFlag
        };

        let allUpdatedSpecialities = [];

        await allSpecialities.map(speciality => {
            if(speciality.id === specialityId) {
                allUpdatedSpecialities.push(specialityObject);
            } else {
                allUpdatedSpecialities.push(speciality);
            }
        });

        await dispatch(myActions.updateSpecialityFilter(allUpdatedSpecialities)).unwrap();
    }

    async function handleProfileCompletenessOptionSelection (optionId, selectionFlag){
        const allProfileCompletenessOptions = entity.profile_completeness_options.value;
        let selectedProfileCompletenessOption = allProfileCompletenessOptions.filter(item => item.id === optionId);

        let profileCompletenessOptionObject = selectedProfileCompletenessOption[0];

        profileCompletenessOptionObject = {
            ...profileCompletenessOptionObject,
            selected: selectionFlag
        };

        let allUpdatedProfileCompletenessOptions = [];

        await allProfileCompletenessOptions.map(profileCompletenessOption => {
            if(profileCompletenessOption.id === optionId) {
                allUpdatedProfileCompletenessOptions.push(profileCompletenessOptionObject);
            } else {
                allUpdatedProfileCompletenessOptions.push(profileCompletenessOption);
            }
        });

        await dispatch(myActions.updateProfileCompletenessOptionFilter(allUpdatedProfileCompletenessOptions)).unwrap();
    }

    async function handleKeywordSearchTerm (e){
        const newSearchTerm = e.target.value;
        await dispatch(myActions.updateSearchTerm(newSearchTerm)).unwrap();
    }


    return (
        <Stack
            sx={{
                minWidth: '1050px',
                justifyContent: 'space-between', flexGrow: '1', gap: 1
            }}
        >
            <Box sx={{ flexGrow: 1 }}>
                <Stack direction="column" sx={{ flexGrow: '1', gap: 1, mt: 0.5 }}>
                    <Stack direction="row" sx={{
                        justifyContent: 'space-between', flexGrow: '1', gap: 1, pr: 1,
                        border: '1px solid #E0E0E066'
                    }}>
                        {/* <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                            {entities_label}
                        </Typography> */}

                        <Stack direction="row" spacing={2} sx={{ mb: 1, mt: 0.5 }} >
                            <Stack sx={{ width: '350px' }}>
                                {/* <Search control={control} sx={{}} /> */}
                                <form name="filterForm" id="filterForm" onSubmit={handleSubmit2(searchProfile)}>
                                    <Search control={control} handleSubmit={handleSubmit2} clearAction={searchProfile} />
                                </form>
                            </Stack>
                            <Button onClick={() => setShowDiscoveryFilter(!showDiscoveryFilter)} variant="outlined" color="primary"
                                size="small" startIcon={<TuneIcon />}
                                endIcon={showDiscoveryFilter ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                sx={{ justifyContent: 'center', backgroundColor: '#FFF', color: '#333333', border: 0 }}>
                                Filter
                            </Button>

                            <Modal
                                aria-labelledby="transition-modal-title"
                                aria-describedby="transition-modal-description"
                                open={openCreateProjectPopup}
                                onClose={handleCreateProjectPopupClose}
                                closeAfterTransition
                                slots={{ backdrop: Backdrop }}
                                slotProps={{
                                    backdrop: {
                                        timeout: 500,
                                    },
                                }}
                            >
                                <Fade in={openCreateProjectPopup}>
                                    <Box sx={CreateProjectPopupStyle}>
                                        <Box sx={{}}>
                                            <Tabs
                                                value={selectedTab}
                                                onChange={handleTabChange}
                                                // indicatorColor="primary"
                                                indicatorColor="none"
                                                textColor="primary"
                                                sx={{
                                                    ".MuiTabs-indicator": {
                                                        display: "none",
                                                    },

                                                }}
                                            >
                                                <Tab label="Create New Project" {...a11yProps(0)} sx={{
                                                    minWidth: '50%', fontSize: '18px',
                                                    fontWeight: (selectedTab === 0) ? 'bold' : 'normal',
                                                    minHeight: 69,
                                                    // background: '#efe2ba',
                                                    // backdropFilter: 'blur(1px)',
                                                    // borderTopLeftRadius: '12px',
                                                    // borderTopRightRadius: '0px',
                                                    // borderBottomRightRadius: '0px'
                                                }} />
                                                <Tab label="Add to Existing Projects" {...a11yProps(1)} sx={{
                                                    minWidth: '50%', fontSize: '18px',
                                                    fontWeight: (selectedTab === 1) ? 'bold' : 'normal',
                                                    // background: '#e3e2df',
                                                    // backdropFilter: 'blur(1px)',
                                                    // borderTopRightRadius: '12px',
                                                    // borderTopLeftRadius: '0px',
                                                    // borderBottomLeftRadius: '0px'
                                                }} />
                                            </Tabs>
                                        </Box>
                                        <CustomTabPanel value={selectedTab} index={0}>
                                            {!(userProject?.loading || userProject?.error) &&
                                                <form name="newProjectForm" id="newProjectForm" onSubmit={handleSubmit(handleCreateProjectAndAddProfiles)}>
                                                    <Stack direction="column" sx={{ flexGrow: '1', gap: 1, mt: 2 }} >
                                                        <Stack direction="column">
                                                            <TextField id="user" name="user" hidden={true} type="text" defaultValue={loggedInUser?.id} {...register('user.id')} />
                                                            <TextField id="communicationMode" name="communicationMode" hidden={true} type="text" defaultValue={userProject?.value?.communicationMode?.id} {...register('communicationMode.id')} />
                                                            <TextField id="type" name="type" type="text" hidden={true} defaultValue={userProject?.value?.type?.id} {...register('type.id')} />
                                                            <TextField id="status" name="status" hidden={true} defaultValue={userProject?.value?.status?.id} type="text" {...register('status.id')} />
                                                            <TextField
                                                                id="commentAndQuestion"
                                                                name="commentAndQuestion"
                                                                type="text"
                                                                variant='outlined'
                                                                color='primary'
                                                                hidden={true}
                                                                label="Additional Comments or Questions"
                                                                placeholder={""}
                                                                inputlabelprops={{ shrink: true }}
                                                                defaultValue={userProject?.value?.commentAndQuestion}
                                                                {...register('commentAndQuestion')}
                                                            />
                                                            <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >
                                                                <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>
                                                                    Project Name   <span style={{ color: 'red' }}>*</span></Typography>
                                                            </Stack>
                                                            <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >



                                                                <TextField
                                                                    id="name"
                                                                    name="name"
                                                                    type="text"
                                                                    variant='outlined'
                                                                    color='primary'
                                                                    // label="Inquiry Details"
                                                                    placeholder={"Project Name"}
                                                                    fullWidth

                                                                    sx={{ mb: 1 }}
                                                                    inputlabelprops={{ shrink: true }}
                                                                    defaultValue={userProject?.value?.name}
                                                                    {...register('name')}
                                                                    error={Boolean(errors.name)}
                                                                    helperText={errors.name ? errors.name.message : ""}
                                                                    inputProps={{
                                                                        maxLength: 60,
                                                                    }}
                                                                />
                                                            </Stack>
                                                            <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >
                                                                <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>
                                                                    Project Description<span style={{ color: 'red' }}>*</span></Typography>
                                                            </Stack>
                                                            <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >


                                                                <TextField
                                                                    id="description"
                                                                    name="description"
                                                                    type="text"
                                                                    variant='outlined'
                                                                    color='primary'
                                                                    // label="Inquiry Description"
                                                                    placeholder={"Project Description"}
                                                                    fullWidth

                                                                    multiline
                                                                    size="normal"
                                                                    rows={3}
                                                                    sx={{
                                                                        mb: 1,
                                                                        '& .MuiInputBase-root': {
                                                                            height: 'auto',
                                                                            maxWidth: '95%'
                                                                        },
                                                                    }}
                                                                    inputProps={{
                                                                        maxLength: 250,

                                                                    }}
                                                                    inputlabelprops={{ shrink: true }}
                                                                    defaultValue={userProject?.value?.description}
                                                                    {...register('description')}
                                                                    error={Boolean(errors.description)}
                                                                    helperText={errors.description ? errors.description.message : ""}
                                                                />
                                                            </Stack>
                                                            <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >
                                                                <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>
                                                                    Keyword / Therapeutic Area / Specialty  <span style={{ color: 'red' }}>*</span></Typography>
                                                            </Stack>
                                                            <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >

                                                                <TextField
                                                                    id="keywordOrTherapeuticArea"
                                                                    name="keywordOrTherapeuticArea"
                                                                    type="text"
                                                                    variant='outlined'
                                                                    color='primary'
                                                                    fullWidth
                                                                    // label="Keyword or Therapeutic Area"
                                                                    sx={{ mb: 1 }}
                                                                    placeholder={"Keyword / Therapeutic Area / Specialty"}
                                                                    inputlabelprops={{ shrink: true }}
                                                                    defaultValue={userProject?.value?.keywordOrTherapeuticArea}
                                                                    {...register('keywordOrTherapeuticArea')}
                                                                    error={Boolean(errors.keywordOrTherapeuticArea)}
                                                                    inputProps={{
                                                                        maxLength: 60,
                                                                    }}
                                                                    helperText={errors.keywordOrTherapeuticArea ? errors.keywordOrTherapeuticArea.message : ""}
                                                                />
                                                            </Stack>
                                                            <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >
                                                                <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>
                                                                    Geographic Scope  <span style={{ color: 'red' }}>*</span></Typography>
                                                            </Stack>
                                                            <Stack direction="row" sx={{ flexGrow: '1' }} >

                                                                <TextField
                                                                    id="geographicScope"
                                                                    name="geographicScope"
                                                                    type="text"
                                                                    variant='outlined'
                                                                    color='primary'
                                                                    // label="Geographic Scope"
                                                                    sx={{ mb: 1 }}
                                                                    fullWidth
                                                                    placeholder={"Geographic Scope"}
                                                                    inputlabelprops={{ shrink: true }}
                                                                    defaultValue={userProject?.value?.geographicScope}
                                                                    {...register('geographicScope')}
                                                                    error={Boolean(errors.geographicScope)}
                                                                    helperText={errors.geographicScope ? errors.geographicScope.message : ""}
                                                                    inputProps={{
                                                                        maxLength: 60,
                                                                    }}
                                                                />
                                                            </Stack>



                                                            {/* <FormControlLabel hidden control={<Checkbox defaultChecked={userProject?.value?.privacyPolicyAcknowledgement} />} label="Privacy Policy Acknowledgement" /> */}
                                                            <FormControl>
                                                                {/* <Stack direction="row" spacing={2} sx={{ justifyContent: 'space-between', mt: 0.5, mb: 4 }} >
                                                                    <Button type={"submit"} variant="contained" color="primary" size="small" endIcon={<SaveIcon />}>
                                                                        Create
                                                                    </Button>
                                                                    <Button onClick={() => reset()} variant="outlined" color="secondary" size="small" endIcon={<SettingsBackupRestoreIcon />}>
                                                                        Reset
                                                                    </Button>
                                                                    <Button onClick={() => handleCreateProjectPopupClose()} variant="outlined" color="secondary" size="small" startIcon={<CancelIcon />}>
                                                                        Cancel
                                                                    </Button>
                                                                </Stack> */}
                                                                <Stack direction="row" spacing={2} sx={{ justifyContent: 'space-between', mt: 0.5, px: 3 }} >
                                                                    <Button type={"submit"} variant="contained" color="primary" size="small"
                                                                        sx={{ fontSize: 16, fontWeight: 600 }}
                                                                    >
                                                                        Create
                                                                    </Button>
                                                                    <Button onClick={() => reset()} variant="outlined" size="small"
                                                                        sx={{ backgroundColor: 'buttonVar.reset', color: 'buttonVar.resetText', fontSize: 16, fontWeight: 600 }}
                                                                    >
                                                                        Reset
                                                                    </Button>
                                                                    <Button onClick={() => { reset(); handleCreateProjectPopupClose() }} variant="outlined"
                                                                        size="small" sx={{ backgroundColor: 'buttonVar.cancel', fontSize: 16, fontWeight: 600 }}  >
                                                                        Cancel
                                                                    </Button>
                                                                </Stack>
                                                            </FormControl>
                                                        </Stack>
                                                    </Stack>
                                                </form>
                                            }
                                        </CustomTabPanel>
                                        <CustomTabPanel value={selectedTab} index={1}>
                                            <form onSubmit={handleSubmit(onSubmit)}>
                                                <Stack direction="column" sx={{ flexGrow: '1', p: 4 }} >
                                                    <Stack direction="column">
                                                        {/* <Typography component="h2" variant="h6" sx={{ fontSize: "16px", mt: 4, mb: 4 }}>
                                                                Select an existing Project
                                                            </Typography> */}
                                                        <FormControl>
                                                            {/* <InputLabel id="select-projects-list-label">Projects</InputLabel> */}
                                                            <Stack direction="row" sx={{ flexGrow: '1', mb: 1 }} >
                                                                <Typography id="select-projects-list-label" variant='body1' sx={{ mb: 0.5, width: '100%' }}>
                                                                    Select an existing Project</Typography>
                                                            </Stack>
                                                            <Stack direction="row" sx={{ flexGrow: '1' }} >


                                                                <Select
                                                                    id="user_project.id"
                                                                    name="user_project.id"
                                                                    labelId="select-projects-list-label"
                                                                    // label="Projects"
                                                                    fullWidth
                                                                    defaultValue={selectedUserProjectId}
                                                                    sx={{
                                                                        mb: 1.5, border: 0, height: '40px', maxWidth: '350px', backgroundColor: '#fff',
                                                                        '&:hover': {
                                                                            backgroundColor: '#fff'
                                                                        },

                                                                    }}
                                                                    onChange={(e) => setSelectedUserProjectId(e.target.value)}
                                                                    value={selectedUserProjectId}
                                                                    MenuProps={{
                                                                        PaperProps: {
                                                                            style: {
                                                                                maxHeight: '40%',
                                                                                width: '350px',
                                                                            },
                                                                        },
                                                                        anchorOrigin: {
                                                                            vertical: 'bottom',
                                                                            horizontal: 'left',
                                                                        },
                                                                        transformOrigin: {
                                                                            vertical: 'top',
                                                                            horizontal: 'left',
                                                                        },
                                                                    }}
                                                                >
                                                                    <MenuItem key={-1} value={-1}>-Select-</MenuItem>
                                                                    {!(userProjects?.loading || userProjects?.error) &&
                                                                        userProjects?.value?.list?.map((userProjectObj) => (
                                                                            <MenuItem key={userProjectObj.id} value={userProjectObj.id}>
                                                                                {userProjectObj.name}
                                                                            </MenuItem>
                                                                        ))}
                                                                </Select>
                                                            </Stack>
                                                        </FormControl>
                                                        <Stack direction="row" spacing={2} sx={{ justifyContent: 'space-between', mt: 0.5, px: 4 }} >
                                                            <Button onClick={() => handleOpenProjectAndAddProfiles()} disabled={selectedUserProjectId === -1}
                                                                type={"button"} variant="contained" color="primary" size="small" sx={{ fontSize: 16, fontWeight: 600 }}
                                                            // endIcon={<SaveIcon />} 
                                                            >
                                                                Add
                                                            </Button>
                                                            <Button onClick={() => setSelectedUserProjectId(-1)} variant="outlined" size="small"
                                                                sx={{ backgroundColor: 'buttonVar.reset', color: 'buttonVar.resetText', fontSize: 16, fontWeight: 600 }}

                                                            // endIcon={<SettingsBackupRestoreIcon />}
                                                            >
                                                                Reset
                                                            </Button>
                                                            <Button onClick={() => handleCreateProjectPopupClose()} variant="outlined" size="small"
                                                                // startIcon={<CancelIcon />}
                                                                sx={{ backgroundColor: 'buttonVar.cancel', fontSize: 16, fontWeight: 600 }}
                                                            >
                                                                Cancel
                                                            </Button>


                                                        </Stack>
                                                    </Stack>
                                                </Stack>
                                            </form>
                                        </CustomTabPanel>
                                    </Box>
                                </Fade>
                            </Modal>
                        </Stack>
                        <Stack direction={"row"}>
                            <Button onClick={() => handleCreateProjectPopupOpen()}
                                disabled={selectedProfileIds.length === 0} variant="contained" color="primary" size="small"
                                endIcon={<AddIcon />} >
                                Create Project
                            </Button>
                            <Stack direction="row" sx={{ ml: 1, minWidth:'125px', justifyContent: 'center', alignItems: 'center' }}>
                                <Stack direction="row">
                                    <Stack direction="row"
                                           sx={{
                                               height: '30px',
                                               backgroundColor: '#666fff',
                                               border: '1px solid rgba(79, 70, 229, 0.20)',
                                               backdropFilter: 'blur(1px)',
                                               borderRadius: '10px',
                                           }}
                                    >
                                        <Typography variant="body1" sx={{ml: 2, mr:2, mt:0.5, mb: 0.5, color: '#FFF',
                                            fontSize: '14px', fontWeight: 600}}>
                                            { totalItems ? totalItems.toLocaleString() : 0 }
                                        </Typography>
                                    </Stack>
                                    <Typography variant="body1" sx={{ml: 0.5, mr: 1, mt:0.5, fontSize: '16px', fontWeight: 600}}>
                                        Profiles
                                    </Typography>
                                </Stack>
                            </Stack>
                        </Stack>
                    </Stack>
                    {/* Dark Performance Stats Console Banner */}
                    <Box
                        sx={{
                            background: 'linear-gradient(to right, #1a1d4e, #403d9d, #8b60e5)',
                            borderRadius: 1,
                            p: 2,
                            color: '#fff',
                            mb: 1
                        }}
                    >
                        <Stack direction="row" spacing={1} sx={{ mb: 1.5 }}>
                            <Stack direction="row" sx={{ bgcolor: 'rgba(255,255,255,0.075)', borderRadius: 2, p: 1.25 }}>
                                <FiberManualRecordRoundedIcon size={'small'} sx={{ mt: 0.5, color: '#00ff00', fontSize: '10px' }}/>
                                <Typography sx={{fontSize: '12px', ml: 0.5}}>
                                    LIVE INTELLIGENCE
                                </Typography>
                            </Stack>
                        </Stack>
                        {totalItems &&
                            <Typography variant="h5" sx={{fontWeight: 700, mb: 3}}>
                                Discovery Console <span style={{
                                fontSize: '0.85rem',
                                color: 'rgba(255,255,255,0.5)',
                                fontWeight: 400
                            }}>Explore {totalItems.toLocaleString()} oncology KOLs worldwide</span>
                            </Typography>
                        }
                        {/* Grid Metrics Rows */}
                        <Grid container spacing={2}>
                            {[
                                { label: 'TOTAL KOLS', val: (totalItems ? totalItems.toLocaleString() :''), change: '▲ 2.4K', color: '#00e676' },
                                { label: 'ACTIVE TRIALS', val: '1,240', change: '▲ 8.2%', color: '#29b6f6' },
                                { label: 'PUBLICATIONS', val: '42.8K', change: '▲ 12%', color: '#ff1744' },
                                { label: 'COUNTRIES', val: '42', change: '', color: '#ffd600' },
                            ].map((item, idx) => (
                                <Grid size={{ xs: 6, sm: 3 }} key={idx}>
                                    <Box sx={{ bgcolor: 'rgba(255,255,255,0.04)', p: 2, borderRadius: 3, position: 'relative', overflow: 'hidden' }}>
                                        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.4)', fontWeight: 600, display: 'block', mb: 0.5 }}>{item.label}</Typography>
                                        <Stack direction="row" alignItems="baseline">
                                            <Typography variant="h5" sx={{ fontWeight: 700 }}>{item.val}</Typography>
                                            {item.change && <Typography variant="caption" sx={{ color: item.color, fontSize: '0.7rem', fontWeight: 600 }}>{item.change}</Typography>}
                                        </Stack>
                                        {/* Fake mini Sparkline visualization */}
                                        <Box sx={{ width: '100%', height: 20, mt: 1, display: 'flex', alignItems: 'flex-end', opacity: 0.6 }}>
                                            <ShowChartIcon sx={{ color: item.color, width: '100%', height: '100%' }} />
                                        </Box>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                    {showDiscoveryFilter &&
                        <Stack direction="column"
                            // sx={{ border: '1px solid #7daad6', mb: 1, borderRadius: '6px' }}
                            sx={{ pb: 2, border: '1px solid #E0E0E066', width: '100%' }}>
                            <form onSubmit={handleSubmit2(searchFilter)}>
                                <Stack direction="column" sx={{ flexGrow: '1', gap: 1, mb: 0, ml: 2, mt: 1 }}>
                                    {!(entity?.specialities?.loading || entity?.specialities.error) &&
                                        <FormControl>
                                            <Stack direction="column" sx={{ flexGrow: '1', gap: 1, mb: 1, ml: 2 }}>
                                                <Stack sx={{ flexGrow: '1' }}>
                                                    {/* <Typography component="h4" variant="h6" sx={{ fontSize: 16 }}> */}
                                                    <Typography variant="body1" sx={{ fontWeight: 600, fontSize: 16 }}>
                                                        KOLs Speciality
                                                    </Typography>
                                                </Stack>
                                                <Stack direction="row" sx={{}}>
                                                    {entity?.specialities?.value?.map(({ id, name, display_name, selected }, index) => (
                                                        <Box key={id}>
                                                            {/*<TextField key={`${id}-speciality`} hidden={true} id={`id`} name={"id"} value={id} {...registerForm2(`specialities.${index}.id`)} />*/}
                                                            {/*<TextField key={`${id}-${name}-speciality`} hidden={true} id={`name`} name={"name"} value={name} {...registerForm2(`specialities.${index}.name`)} />*/}
                                                            {/*<TextField key={`${id}-display-${display_name}-speciality`} hidden={true} id={`display_name`} name={"display_name"} value={display_name} {...registerForm2(`specialities.${index}.display_name`)} />*/}
                                                            <FormControlLabel componentsProps={{ typography: { fontSize: '14px' } }} control={<Checkbox sx={{
                                                                border: '2px solid #4C58B2', boxShadow: 0,
                                                            }} defaultChecked={selected} {...registerForm2(`specialities.${index}.selected`)} />} key={id} label={display_name} onClick={() => { handleSpecialitiesSelection(id, !selected); setFilterModifiedFlag(true);}} />
                                                        </Box>
                                                    ))}
                                                </Stack>
                                            </Stack>
                                        </FormControl>
                                    }
                                </Stack>
                                <Stack direction="row" sx={{ ml: 2, width: '100%' }}>
                                    <Stack direction="column" sx={{width: '50%' }}>
                                        {!(entity?.continents?.value?.loading || entity?.continents?.value?.error) &&
                                        <FormControl>
                                            <Stack direction="column" sx={{ flexGrow: '1', gap: 1, mb: 2, ml: 2 }}>
                                                <Stack sx={{ flexGrow: '1' }}>
                                                    {/* <Typography component="h4" variant="h6" sx={{ fontSize: 16 }}> */}
                                                    <Typography variant="body1" sx={{ fontWeight: 600, fontSize: 16 }}>
                                                        Preferred geographic locations of the KOLs
                                                    </Typography>
                                                </Stack>
                                                <Stack direction="row" sx={{ flexGrow: '1', flexWrap: 'wrap' }}>
                                                    {entity?.continents?.value?.map(({ id, name, selected, showCountryFilter, countries, hidden }, index) => (
                                                        <Box key={`${id}-continents}`} >
                                                            <FormControlLabel componentsProps={{ typography: { fontSize: '14px' } }} control={<Checkbox sx={{
                                                                borderRadius: 0, border: '2px solid #4C58B2', boxShadow: 0, mt: 1
                                                            }} defaultChecked={selected} {...registerForm2(`continents.${index}.selected`)} />} hidden={hidden} key={id} label={name} onClick={() => { handleContinentSelection(id, !selected); setFilterModifiedFlag(true);}} />
                                                            {!hidden && !showCountryFilter && countries?.length > 0 &&
                                                            <IconButton color="primary" size={"small"} sx={{mt:0, ml: -1, mr: 3, border: 0}} aria-label="add to shopping cart" onClick={() => setShowCountryfilterByContinentId(id, !showCountryFilter)}>
                                                                <KeyboardArrowRightIcon />
                                                            </IconButton>
                                                            }
                                                            {!hidden && showCountryFilter && countries?.length > 0 &&
                                                            <FormControl key={`${id}-geographic-country`} sx={{ mt:0, width: 400,}}>
                                                                <InputLabel>{name}</InputLabel>
                                                                <Select
                                                                    key={`${id}--select-geographic-country`}
                                                                    multiple
                                                                    value={countries}
                                                                    {...register(`continents.${index}.countries`)}
                                                                    sx={{display: "flex",
                                                                        flexDirection: "row",
                                                                        // height: 'px',
                                                                        overflow: "hidden",
                                                                        overflowY: "auto",
                                                                        border: 0,
                                                                    }}
                                                                    input={<OutlinedInput label="Multiple Select" />}
                                                                    onClose={()=> renderUpdatedCountrySelectionList()}
                                                                    renderValue={(countries) => (
                                                                        <Stack gap={0.5} direction="row" flexWrap="wrap"
                                                                               sx={{height: '100%',}}
                                                                            // sx={{display: "flex",
                                                                            //     flexDirection: "row",
                                                                            //      height: '25px',
                                                                            //     // overflow: "hidden",
                                                                            //     overflowX: "scroll"}}
                                                                        >
                                                                            {countries?.map(({ id: country_id, name: country_name, shortName: country_shortName, selected: country_selected }, countryIndex) => (
                                                                                country_selected &&
                                                                                <Chip
                                                                                    id={"countries"}
                                                                                    name={"countries"}
                                                                                    key={country_id}
                                                                                    label={country_name}
                                                                                    onDelete={async () => {
                                                                                        await handleCountrySelection(id, country_id, !country_selected);
                                                                                        renderUpdatedCountrySelectionList();
                                                                                        //value.selected = true
                                                                                        // setSelectedNames(
                                                                                        //     selectedNames.filter((item) => item !== value)
                                                                                        // )
                                                                                    }
                                                                                    }
                                                                                    sx={{fontSize: '10px'}}
                                                                                    deleteIcon={
                                                                                        <CancelIcon
                                                                                            onMouseDown={(event) => event.stopPropagation()}
                                                                                        />
                                                                                    }
                                                                                />
                                                                            ))}
                                                                        </Stack>
                                                                    )}
                                                                >
                                                                    {countries.map(({ id: country_id, name: country_name, shortName: country_shortName, selected: country_selected }, countryIndex) => (
                                                                        <Box key={`${id}-countries`} >
                                                                            <FormControlLabel componentsProps={{ typography: { fontSize: '14px' } }} control={<Checkbox sx={{
                                                                                borderRadius: 0, border: '2px solid #4C58B2', boxShadow: 0,
                                                                            }} defaultChecked={country_selected} {...registerForm2(`continents.${index}.countries.${countryIndex}.selected`)} onClick={(e)=> {setTimeout(function(){handleCountrySelection(id, country_id, !country_selected)},100); setFilterModifiedFlag(true);}} />} key={country_id} label={country_name} />
                                                                        </Box>
                                                                        // <MenuItem
                                                                        //     key={country_id}
                                                                        //     value={country_name}
                                                                        //     onClick={(e)=> {
                                                                        //         handleCountrySelection(id, country_id, !country_selected);
                                                                        //         setFilterModifiedFlag(true);
                                                                        //     }}
                                                                        //     sx={{ justifyContent: "space-between" }}
                                                                        // >
                                                                        //     {country_name}
                                                                        //     {country_selected ? <CheckIcon color="info" /> : null}
                                                                        // </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </FormControl>
                                                            }
                                                            {!hidden && showCountryFilter && countries?.length > 0 &&
                                                            <IconButton color="primary" size={"small"} sx={{ml:1, mt:1, mr: 3, border:0}} onClick={() => setShowCountryfilterByContinentId(id, !showCountryFilter)}>
                                                                <KeyboardArrowLeftIcon />
                                                            </IconButton>
                                                            }
                                                            {/*{countries?.map(({ id, name, shortName, selected }, index) => (*/}
                                                            {/*    <Box key={`${id}-countries}`} sx={{ml:4}}>*/}
                                                            {/*        <TextField key={`${id}-subGeographic`} hidden id={`id`} name={"id"} value={id} {...register(`countries.${index}.id`)} />*/}
                                                            {/*        <TextField key={`${id}-${name}-subGeographic`} hidden id={`name`} name={"name"} value={name} {...register(`countries.${index}.name`)} />*/}
                                                            {/*        <TextField key={`${id}-display-${shortName}-subGeographic`} hidden id={`shortName`} name={"shortName"} value={shortName} {...register(`countries.${index}.shortName`)} />*/}
                                                            {/*        <FormControlLabel componentsProps={{ typography: { fontSize: '14px' } }} control={<Checkbox sx={{*/}
                                                            {/*            borderRadius: 0, border: '2px solid #4C58B2', boxShadow: 0,*/}
                                                            {/*        }} defaultChecked={selected}  {...register(`countries.${index}.selected`)} />} key={id} label={shortName} onClick={() => setFilterModifiedFlag(true)} />*/}

                                                            {/*    </Box>*/}
                                                            {/*))}*/}
                                                        </Box>
                                                    ))}
                                                </Stack>
                                            </Stack>
                                        </FormControl>
                                        }
                                        {!(entity?.profile_completeness_options?.loading || entity?.profile_completeness_options?.error) &&
                                        <Stack direction="column" sx={{ flexGrow: '1', gap: 1, mb: 2 }}>
                                            <FormControl>
                                                <Stack direction="column" sx={{ flexGrow: '1', gap: 1, ml: 2 }}>
                                                    <Stack sx={{ flexGrow: '1' }}>
                                                        {/* <Typography component="h4" variant="h6" sx={{ fontSize: 16 }}> */}
                                                        <Typography variant="body1" sx={{ fontWeight: 600, fontSize: 16 }}>
                                                            Profile List Category
                                                        </Typography>
                                                    </Stack>
                                                    <Stack direction="row" sx={{}}>
                                                        {entity?.profile_completeness_options?.value?.map(({ id, name, display_name, selected }, index) => (
                                                            <Box key={id}>
                                                                <FormControlLabel componentsProps={{ typography: { fontSize: '14px' } }} control={<Checkbox sx={{
                                                                    border: '2px solid #4C58B2', boxShadow: 0,
                                                                }} defaultChecked={selected} {...registerForm2(`specialities.${index}.selected`)} />} key={id} label={display_name} onClick={() => { handleProfileCompletenessOptionSelection(id, !selected); setFilterModifiedFlag(true);}} />
                                                            </Box>
                                                        ))}
                                                    </Stack>
                                                </Stack>
                                            </FormControl>
                                        </Stack>
                                        }
                                    </Stack>
                                    <Stack direction="row" sx={{ width: '50%' }}>
                                        <FormControl fullWidth>
                                            {!(entity?.search_terms?.value?.loading || entity?.search_terms?.value?.error) &&
                                            <Stack direction="column" sx={{
                                                mb: 1, ml: 2,
                                                // borderLeft: '1px solid #7daad6'
                                                width: '100%'
                                            }}>
                                                <Stack sx={{ justifyContent: 'space-between', flexGrow: '1', gap: 1 }}>
                                                    {/* <Typography component="h4" variant="h6" sx={{ fontSize: 16 }}> */}
                                                    <Typography variant="body1" sx={{ fontWeight: 600, fontSize: 16 }}>
                                                        Therapeutic areas / MeSH terms
                                                    </Typography>
                                                </Stack>
                                                <Stack sx={{ justifyContent: 'space-between', flexGrow: '1', mt: 1 }}>
                                                    <TextField
                                                        id="search_terms"
                                                        name="search_terms"
                                                        type="text"
                                                        variant='outlined'
                                                        color='primary'
                                                        multiline
                                                        fullWidth
                                                        size="normal"
                                                        rows={3}
                                                        sx={{
                                                            mb: 1.5,
                                                            '& .MuiInputBase-root': {
                                                                height: 'auto',
                                                                width: '100%',
                                                                maxWidth: '97%'
                                                            },
                                                        }}
                                                        placeholder={"MeSH terms"}
                                                        defaultValue={entity?.search_terms?.value?.search_terms}
                                                        inputlabelprops={{ shrink: true }}
                                                        {...registerForm2('search_terms')}
                                                        onChange={(e) => {handleKeywordSearchTerm(e); setFilterModifiedFlag(true);}}
                                                    />
                                                </Stack>
                                            </Stack>
                                            }
                                        </FormControl>
                                    </Stack>
                                </Stack>
                                <Stack direction="row" sx={{ justifyContent: 'center' }}>
                                    <Stack direction="column" sx={{ gap: 1, ml: 2 }}>
                                        <Button onClick={() => { resetDiscoveryFilter(); setFilterModifiedFlag(false); }} disabled={!filterModifiedFlag}
                                            variant="contained" color="primary" size="small" endIcon={<ClearIcon />}>
                                            Clear
                                        </Button>
                                    </Stack>
                                    <Stack direction="column" sx={{ gap: 1, ml: 2 }}>
                                        <Button variant="contained" color="primary" type="submit" disabled={!filterModifiedFlag}
                                            endIcon={<ArrowForwardOutlined />}>Search</Button>
                                    </Stack>
                                </Stack>
                            </form>
                        </Stack>
                    }
                    <Stack direction="column" sx={{ flexGrow: '1', minWidth: '800px' }} >
                        <Box sx={{ width: '100%' }}>
                            <Tabs
                                value={selectedModuleId}
                                onChange={handleDiscoveryTabChange}
                                indicatorColor="none"
                                textColor="primary"
                                sx={{
                                    ".MuiTabs-indicator": {
                                        display: "none",
                                    },
                                    // borderRadius: 0,
                                    // backgroundColor: '#F6F8FB',
                                    width: '100%',
                                    height: '50px',
                                }}
                            >
                                <CustomDiscoveryTab
                                    label={"All"}
                                    icon={<PeopleAltIcon />} iconPosition="start"
                                    disabled={loading}
                                    {...a11yDiscoveryProps(0)}
                                    sx={{
                                        minWidth: '25%',
                                        fontSize: '20px',
                                        fontWeight: selectedModuleId === 0 ? 'bold' : 'normal',
                                    }}
                                />
                                <CustomDiscoveryTab
                                    label={"KOL"}
                                    icon={<Person2Icon />} iconPosition="start"
                                    disabled={loading}
                                    {...a11yDiscoveryProps(1)}
                                    sx={{
                                        minWidth: '25%',
                                        fontSize: '20px',
                                        fontWeight: selectedModuleId === 1 ? 'bold' : 'normal',
                                    }}
                                />
                                <CustomDiscoveryTab
                                    label={"KOL/DOL"}
                                    icon={<RecentActorsIcon />} iconPosition="start"
                                    disabled={loading}
                                    {...a11yDiscoveryProps(2)}
                                    sx={{
                                        minWidth: '25%',
                                        fontSize: '20px',
                                        fontWeight: selectedModuleId === 2 ? 'bold' : 'normal',
                                    }}
                                />
                                <CustomDiscoveryTab
                                    label={"DOL"}
                                    icon={<TagIcon />} iconPosition="start"
                                    disabled={loading}
                                    {...a11yDiscoveryProps(3)}
                                    sx={{
                                        minWidth: '25%',
                                        fontSize: '20px',
                                        fontWeight: selectedModuleId === 3 ? 'bold' : 'normal',
                                    }}
                                />
                            </Tabs>
                        </Box>
                        <Grid container spacing={2} columns={12}>

                            <Grid size={{ md: 12, lg: 12 }}>

                                <DataGrid
                                    apiRef={gridApiRef}
                                    autoHeight
                                    // rowHeight={80}
                                    getRowHeight={(params) => 'auto'}
                                    // getRowHeight={(params) => {
                                    //     // if (params.model.firstname === 'Abimbola') {
                                    //     const baseHeight = 80;
                                    //     const charLength = [
                                    //         params.model.salutation,
                                    //         params.model.firstname,
                                    //         params.model.lastname,
                                    //         params.model.suffix
                                    //     ].reduce((totalLength, field) => totalLength + (field ? field.length : 0), 0);
                                    //     const charLimit = 26;
                                    //     const lines = Math.ceil(charLength / charLimit);

                                    //     const extraHeight = lines > 1 ? (lines - 1) * 35 : 0;

                                    //     return baseHeight + extraHeight;
                                    //     // }
                                    //     // return 80;

                                    // }}
                                    checkboxSelection
                                    disableColumnFilter
                                    disableColumnMenu
                                    disableColumnSelector
                                    disableColumnResize
                                    hideFooterPagination
                                    rows={entities}
                                    columns={renderColumns(selectedModuleId)}
                                    getRowId={(row) => row.id}
                                    getRowClassName={(params) =>
                                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                    }
                                    loading={loading}
                                    onStateChange={(newState) => {
                                        if (newState && newState.page) {
                                            setLoading(false);
                                        }
                                    }}

                                    components={{
                                        LoadingOverlay: CircularProgress,
                                    }}
                                    sx={{
                                        // flexGrow: 1,
                                        minHeight: 550,
                                        height: '100%',
                                        border: 0,
                                        '& .MuiDataGrid-topContainer': {
                                            color: '#fff',
                                            // border: 0
                                        },
                                        '& .MuiDataGrid-row': {
                                            borderBottom: 0
                                        },
                                        '& .MuiDataGrid-columnHeaders': {
                                            justifyContent: "center",
                                            alignItems: "left"
                                        },
                                        '& .MuiDataGrid-row:hover .corner-value': {
                                            visibility: 'visible',
                                            opacity: 1,
                                        },

                                    }}
                                    sortingMode="server"
                                    sortingOrder={['asc', 'desc']}
                                    sortModel={sortModel}
                                    onSortModelChange={(newSortModel) => {
                                        setLoading(true);
                                        setSortModel(newSortModel);
                                        updatePageFilter({
                                            sortField: newSortModel[0]?.field,
                                            sortDirection: newSortModel[0]?.sort,
                                            pageNumber: 1
                                        });


                                    }}
                                    keepNonExistentRowsSelected
                                    onRowSelectionModelChange={(selectedRowIds) => {
                                        setSelectedProfileIds(selectedRowIds);
                                        // const selectedIDs = new Set(ids);
                                        // const selectedRowData = entities?.filter((row) => selectedIDs.has(row.id.toString()));
                                    }}
                                    initialState={{}}
                                    slotProps={{
                                        filterPanel: {
                                            // filterFormProps: {
                                            //     logicOperatorInputProps: {
                                            //         variant: 'outlined',
                                            //         size: 'small',
                                            //     },
                                            //     columnInputProps: {
                                            //         variant: 'outlined',
                                            //         size: 'small',
                                            //         sx: {mt: 'auto'},
                                            //     },
                                            //     operatorInputProps: {
                                            //         variant: 'outlined',
                                            //         size: 'small',
                                            //         sx: {mt: 'auto'},
                                            //     },
                                            //     valueInputProps: {
                                            //         InputComponentProps: {
                                            //             variant: 'outlined',
                                            //             size: 'small',
                                            //         },
                                            //     },
                                            // },
                                        }
                                    }}
                                />


                            </Grid>
                        </Grid>
                        {(totalPages > 1) &&
                            <Pagination variant="outlined" color="primary" count={totalPages} page={pageFilter.pageNumber} onChange={navigatePage} />
                        }                    </Stack>
                </Stack >
            </Box >
        </Stack >
    );
}